__turbopack_context__.v({
  "author-icon-img": "AtbJUG_author-icon-img",
  "author-result-card": "AtbJUG_author-result-card",
  "authorIconTop": "AtbJUG_authorIconTop",
  "authorLinkImage": "AtbJUG_authorLinkImage",
  "book-deals": "AtbJUG_book-deals",
  "book-result-card": "AtbJUG_book-result-card",
  "card-img-top": "AtbJUG_card-img-top",
  "catelog-card-img-top": "AtbJUG_catelog-card-img-top",
  "contentCard": "AtbJUG_contentCard",
  "feedbackpage__bookimage": "AtbJUG_feedbackpage__bookimage",
  "giveawaypage__bookimage": "AtbJUG_giveawaypage__bookimage",
  "h-card-img-top": "AtbJUG_h-card-img-top",
  "img-default": "AtbJUG_img-default",
  "instructional": "AtbJUG_instructional",
  "post-card-img": "AtbJUG_post-card-img",
  "promoImage": "AtbJUG_promoImage",
  "retailer": "AtbJUG_retailer",
  "v-card-img-top": "AtbJUG_v-card-img-top",
});
